export const convertDateFromRuLocales = function(date) {
    if (date) {
        return date
            .split('.')
            .reverse()
            .join('-');
    }
};

const compareDatesForEquality = function(firstDate, secondDate) {
    const firstDateNullTime = firstDate.setHours(0, 0, 0, 0);
    const secondDateNullTime = secondDate.setHours(0, 0, 0, 0);
    return firstDateNullTime === secondDateNullTime;
};

const isDateListIncludesDate = function(dateList, date) {
    for (const item of dateList) {
        if (compareDatesForEquality(item, date)) {
            return true;
        }
    }
    return false;
};

export const convertFromRuLocaleDateList = function(dateList) {
    if (!Array.isArray(dateList)) return null;
    let dates = [];
    try {
        if (!dateList || !dateList.length) return dates;
        dates = dateList.map((date) => {
            return new Date(convertDateFromRuLocales(date));
        });
    } catch (e) {
        console.error(e);
    }
    return dates;
};

export const checkDateAvailability = function(availableDates, disabledDates, date) {
    let dateDisabled;
    let dateAvailable;

    if (availableDates) {
        dateAvailable = isDateListIncludesDate(availableDates, date);
    } else {
        dateAvailable = true;
    }

    if (disabledDates) {
        dateDisabled = isDateListIncludesDate(disabledDates, date);
    } else {
        dateDisabled = false;
    }

    return dateAvailable && !dateDisabled;
};
